// Selector de portal para quien tiene 2 o más: muestra solo los portales que sus permisos abren.
import { Link } from '@tanstack/react-router';
import { ArrowRight, LayoutDashboard } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useAuth } from '@/hooks/useAuth';
import { ProfileGate } from '@/shared/patterns/AppShell/ProfileGate';
import { portalsFor } from './portalAccess';
import { ROLE_ENTRIES } from './roles';

export function RoleSelector() {
    return (
        <ProfileGate>
            <RoleSelectorContent />
        </ProfileGate>
    );
}

function RoleSelectorContent() {
    const { permissions } = useAuth();
    const portals = portalsFor(permissions);
    return (
        <div className="mx-auto flex min-h-screen w-full max-w-2xl flex-col items-center bg-background px-6 py-16">
            <div className="flex size-14 items-center justify-center rounded-2xl bg-slate-900 text-white">
                <LayoutDashboard className="size-7" aria-hidden />
            </div>
            <h1 className="mt-6 text-center text-2xl font-bold tracking-tight text-foreground">
                Elige un portal para entrar
            </h1>
            <p className="mt-3 max-w-md text-center text-sm leading-relaxed text-muted-foreground">
                Tu cuenta tiene acceso a varios portales. Elige con cuál quieres trabajar; puedes
                cambiar después desde el menú.
            </p>

            <nav className="mt-10 w-full space-y-3">
                {portals.map(({ id }) => {
                    const role = ROLE_ENTRIES[id];
                    return (
                        <Link
                            key={id}
                            {...role.link}
                            className="group flex items-center gap-4 rounded-xl border border-border bg-card px-5 py-4 transition-colors hover:border-foreground/30 hover:bg-accent/40"
                        >
                            <span
                                className={cn(
                                    'flex size-11 shrink-0 items-center justify-center rounded-xl',
                                    role.iconClass,
                                )}
                            >
                                <role.Icon className="size-5" aria-hidden />
                            </span>
                            <span className="min-w-0 flex-1">
                                <span className="block text-[15px] font-semibold text-foreground">
                                    {role.label}
                                </span>
                                <span className="block truncate text-sm text-muted-foreground">
                                    {role.description}
                                </span>
                            </span>
                            <ArrowRight
                                className="size-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5"
                                aria-hidden
                            />
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
}
